<template>
  <div class="left-menu-wrapper">
    <v-navigation-drawer
      v-model="drawer"
      class="base-card left-menu ml-4 shadow"
      width="285"
      mobile-breakpoint="xs"
      absolute
      app
      floating
      permanent
      :mini-variant="mini"
      :mini-variant-width="72"
      :clipped="false"
    >
      <v-card class="whiteBlack">
        <v-card-title class="justify-end pa-2">
          <v-btn
            class="ml-4"
            icon
            small
            plain
            :title="mini ? 'Показать меню' : 'Скрыть меню'"
            @click="mini = !mini"
          >
            <v-icon
              class="uikit-icon chevron-left-circle delay-03"
              :class="mini ? 'rotate-180' : ''"
            />
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-2 pt-0">
          <MenuLinks
            :links="links"
            :mini="mini"
          />
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import MenuLinks from '@/components/ui/MenuLinks'

export default {
  name: 'LeftMenu',

  props: {
    links: Array
  },

  components: {
    MenuLinks
  },

  data: () => ({
    drawer: false,
    mini: false
  })
}
</script>

<style scoped>
.left-menu {
  background: var(--v-background-base) !important;
  margin-top: calc(76px);
  /*max-height: 316px !important;*/
  height: auto !important;
}

.left-menu-wrapper {
  display: flex;
  flex-direction: column;
}
</style>
